export default __webpack_public_path__ + "static/media/safebridge_l_i.adc5b41d.svg";